import { inject, Service } from '@angular/core';
import { ResourceType } from '@thiememeulenhoff/types';
import { ServicesService } from '../services';

@Service()
export class ContentEndpointsService {
  readonly #service = inject(ServicesService);

  #contentBackend(endpoint: string) {
    return this.#service.vesta(endpoint);
  }

  #managementContentBackend(endpoint: string) {
    return this.#service.vesta(`management/${endpoint}`);
  }

  public arrangements() {
    return this.#contentBackend(`arrangement`);
  }

  public arrangementByCode(arrangementCode: string) {
    return this.#contentBackend(`arrangement/${arrangementCode}`);
  }

  public saveArrangement(arrangementCode: string) {
    return this.#contentBackend(`arrangement/${arrangementCode}/resource`);
  }

  public createArrangement() {
    return this.#contentBackend(`arrangement`);
  }

  public vdexDefinitionByApiField(arrangementCode: string, apiField: string) {
    return this.#contentBackend(
      `arrangement/${arrangementCode}/vdex/${apiField}`,
    );
  }

  public vdexByApiField(apiField: string) {
    return this.#contentBackend(`vdex/${apiField}`);
  }

  public clusters() {
    return this.#contentBackend(`cluster`);
  }

  public clusterByMethodSlug(methodSlug: string) {
    return this.#contentBackend(`method/${methodSlug}/clusters`);
  }

  public resourcesByArrangementCode(arrangementCode: string) {
    return this.#contentBackend(`arrangement/${arrangementCode}/resource`);
  }

  public resourcesByMethodSlug(
    methodSlug: string,
    resourceType: ResourceType | null = null,
  ) {
    if (resourceType) {
      return this.#contentBackend(
        `method/${methodSlug}/resource/${resourceType}`,
      );
    }

    return this.#contentBackend(`method/${methodSlug}/resource`);
  }

  public multipleResources() {
    return this.#contentBackend(`arrangement/resource/multiple`);
  }

  public methods() {
    return this.#contentBackend(`method`);
  }

  public methodBySlug(methodSlug: string) {
    return this.#contentBackend(`method/${methodSlug}`);
  }

  public contentById(streamCode: string, contentIdentifier: string) {
    return this.#contentBackend(
      `arrangement/${streamCode}/content/html/identifier/${contentIdentifier}`,
    );
  }

  public managementArrangements() {
    return this.#managementContentBackend(`arrangement`);
  }

  public managementArrangementByCode(arrangementCode: string) {
    return this.#managementContentBackend(`arrangement/${arrangementCode}`);
  }

  public managementResourcesByArrangementCode(arrangementCode: string) {
    return this.#managementContentBackend(
      `arrangement/${arrangementCode}/resource`,
    );
  }

  public managementContentById(streamCode: string, contentIdentifier: string) {
    return this.#managementContentBackend(
      `arrangement/${streamCode}/content/html/identifier/${contentIdentifier}`,
    );
  }

  public rawContentById(streamCode: string, contentIdentifier: string) {
    return this.#contentBackend(
      `arrangement/${streamCode}/content/identifier/${contentIdentifier}`,
    );
  }

  public search() {
    return this.#service.thip(`search/resource`);
  }

  contentByPath(streamCode: string, contentPath: string) {
    return this.#contentBackend(
      `arrangement/${streamCode}/content/html/path/${contentPath}`,
    );
  }
}
